import { Component, OnInit, OnDestroy } from '@angular/core';
// import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { HttpEventType } from '@angular/common/http';
import { IJourney, CortevaParticipant } from 'src/app/core/journey-core/journey.interface';
import { JourneyCoreService } from 'src/app/core/journey-core/journey-core.service';
import { NotificationService, NotificationType } from 'src/app/notification/notification/notification.service';
import { environment } from 'src/environments/environment';
import { JourneyService } from '../journey.service';
import { CortevaDBService } from './corteva-db.service';
import { AuthCoreService } from 'src/app/core/auth-core/auth-core.service';

@Component({
  selector: 'app-corteva-db',
  templateUrl: './corteva-db.component.html',
})
export class CortevaDbComponent implements OnInit, OnDestroy {
  private _unsubscribe$ = new Subject<void>();
  
  // journey: IJourney | null = null; // Removed per user request
  // journeyId: string = ''; // Removed per user request
  // isLoading = false; // Removed as journey loading is removed
  isUploading = false;
  uploadProgress = 0;
  uploadedFile: File | null = null;
  
  participants: CortevaParticipant[] = [];
  filteredParticipants: CortevaParticipant[] = [];
  searchTerm: string = '';

  showEditModal = false;
  selectedParticipant: Partial<CortevaParticipant> = {};
  isUpdating = false;

  constructor(
    // private _activatedRoute: ActivatedRoute, // Removed
    private _journeyCoreService: JourneyCoreService,
    private _notificationService: NotificationService,
    private _journeyService: JourneyService,
    private _cortevaDBService: CortevaDBService
  ) {}

  ngOnInit(): void {
    // Removed journeyId logic
    this.loadParticipants();
  }

  // loadJourney(): void { ... } // Removed

  limit = 50;
  offset = 0;
  isLoading = false;
  isLoadingMore = false;
  hasMoreData = true;

  loadParticipants(isLoadMore = false): void {
    if (isLoadMore) {
        this.isLoadingMore = true;
        this.offset += this.limit;
    } else {
        this.isLoading = true;
        this.offset = 0;
    }

    this._cortevaDBService.getParticipants(this.limit, this.offset)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe({
        next: (newParticipants) => {
          this.isLoading = false;
          this.isLoadingMore = false;
          
          if (newParticipants.length < this.limit) {
              this.hasMoreData = false;
          } else {
              this.hasMoreData = true;
          }

          if (isLoadMore) {
              this.participants = [...this.participants, ...newParticipants];
          } else {
              this.participants = newParticipants;
          }
          
          if (!this.searchTerm.trim()) {
            this.filteredParticipants = this.participants;
          }
        },
        error: (error: any) => {
          this.isLoading = false;
          this.isLoadingMore = false;
          console.error('Failed to load participants', error);
        }
      });
  }

  loadMore(): void {
      this.loadParticipants(true);
  }

  onDownload(): void {
    this._cortevaDBService.downloadPlayersDb()
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe({
        next: (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = 'Corteva-players.xlsx';
          anchor.click();
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          console.error('Download failed', err);
          this._notificationService.showNotification('Failed to download players DB', NotificationType.ERROR);
        }
      });
  }
  getMockParticipants(): CortevaParticipant[] {
    return Array.from({ length: 10 }, (_, i) => ({
      name: `User ${i + 1}`,
      email: `user${i + 1}@example.com`,
      designation: 'Manager',
      mobileNumber: '1234567890',
      cuZone: 'North',
      state: 'Delhi',
      territory: 'T1',
      reportingManagerName: 'Boss Man'
    }));
  }

  onSearch(): void {
    if (!this.searchTerm.trim()) {
      this.loadParticipants(); // Reset to all participants if search is empty
      return;
    }

    this._cortevaDBService.searchParticipants(this.searchTerm.trim())
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe({
        next: (response: any) => { // Using any to check if it's array or single object
          if (Array.isArray(response)) {
            this.filteredParticipants = response;
          } else if (response && typeof response === 'object') {
            // If single object returned, wrap in array
            this.filteredParticipants = [response as CortevaParticipant];
          } else {
             this.filteredParticipants = [];
          }
        },
        error: (err) => {
          console.error('Search failed', err);
          this._notificationService.showNotification('Search failed', NotificationType.ERROR);
        }
      });
  }

  onSearchChange(term: string): void {
      if (!term.trim()) {
          this.loadParticipants();
      }
  }

  get gameFormatName(): string {
    // return this._journey ? 
    //   this._journeyService.genieGameNames[this.journey?.gameFormat as keyof typeof this._journeyService.genieGameNames] || '' : '';
    return '';
  }
  
  // Helper getter because I used `journey` in the template but `_journey` check in getter above was habit.
  // Actually I used `journey` property.
  // get _journey() { return this.journey; }

  downloadTemplate(): void {
    // Determine where the template is hosted. Using the same one as invite-users for now or a placeholder.
    // If Corteva has a specific template, it should be a specific URL.
    // Proceeding with a placeholder URL that might need to be invalid or standard one.
    // For now using the same download logic but maybe we need a specific one?
    // User didn't specify, so I'll use a generic download link or same as before.
    const url = `https://assets.talentlitmus.com/file/cortevauserDB-1770007465891.xlsx`; 
    window.open(url, '_blank');
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadedFile = input.files[0];
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      const validExtensions = ['.xlsx', '.xls', '.csv'];
      const fileName = file.name.toLowerCase();
      if (validExtensions.some(ext => fileName.endsWith(ext))) {
        this.uploadedFile = file;
      } else {
        this._notificationService.showNotification('Invalid file type', NotificationType.ERROR);
      }
    }
  }

  uploadFile(): void {
    if (!this.uploadedFile) return;

    this.isUploading = true;
    this.uploadProgress = 0;

    // Service call disabled as it requires journeyId
    // Use companyId from user request: 6138735afa514e001269cb2c or fetch from auth service
    // Assuming AuthCoreService has the companyId or using the one from the curl command if hardcoding is needed for now.
    // However, best practice is to get it from the logged in user's company.
    const companyId = AuthCoreService.companyUser?.company?._id || '6138735afa514e001269cb2c'; // Fallback to provided ID if auth not ready

    this._cortevaDBService.uploadParticipants(this.uploadedFile, companyId)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe({
        next: (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.uploadProgress = Math.round(100 * event.loaded / (event.total || 1));
          } else if (event.type === HttpEventType.Response) {
            this.isUploading = false;
            this.uploadProgress = 0;
            this.uploadedFile = null;
            this._notificationService.showNotification('Participants uploaded successfully!', NotificationType.INFO);
            this.loadParticipants();
          }
        },
        error: (error: any) => {
          console.error('Upload Error Details:', error);
          this.isUploading = false;
          this.uploadProgress = 0;
          
          let errorMessage = 'Failed to upload participants';
          if (error?.error?.message) {
            errorMessage = error.error.message;
          } else if (typeof error?.error === 'string') {
            errorMessage = error.error;
          } else if (error?.message) {
            errorMessage = error.message;
          }

          this._notificationService.showNotification(errorMessage, NotificationType.ERROR);
        }
      });
  }


  onEdit(participant: CortevaParticipant): void {
    this.selectedParticipant = { ...participant };
    this.showEditModal = true;
  }

  closeModal(): void {
    this.showEditModal = false;
    this.selectedParticipant = {};
  }

  saveUpdate(): void {
    if (!this.selectedParticipant._id) return;

    this.isUpdating = true;
    this._cortevaDBService.updateParticipant(this.selectedParticipant)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe({
        next: () => {
          this.isUpdating = false;
          this.showEditModal = false;
          this._notificationService.showNotification('Participant updated successfully', NotificationType.INFO);
          this.loadParticipants();
        },
        error: (err) => {
          this.isUpdating = false;
          console.error('Update failed', err);
          
          let errorMessage = 'Failed to update participant';
          if (err?.error?.message) {
            errorMessage = err.error.message;
          } else if (typeof err?.error === 'string') {
            errorMessage = err.error;
          } else if (err?.message) {
            errorMessage = err.message;
          }
          
          this._notificationService.showNotification(errorMessage, NotificationType.ERROR);
        }
      });
  }

  showDeleteModal = false;
  participantToDelete: CortevaParticipant | null = null;
  isDeleting = false;

  onDelete(participant: CortevaParticipant): void {
    this.participantToDelete = participant;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
    this.participantToDelete = null;
  }

  confirmDelete(): void {
    if (!this.participantToDelete || !this.participantToDelete._id) {
         this._notificationService.showNotification('Cannot delete: Missing ID', NotificationType.ERROR);
         return;
    }

    this.isDeleting = true;
    this._cortevaDBService.deleteParticipant(this.participantToDelete._id, this.participantToDelete.email)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe({
        next: () => {
          this.isDeleting = false;
          this.closeDeleteModal();
          this._notificationService.showNotification('Participant deleted successfully', NotificationType.INFO);
          this.loadParticipants();
        },
        error: (err) => {
          this.isDeleting = false;
          console.error('Delete failed', err);
          
          let errorMessage = 'Failed to delete participant';
          if (err?.error?.message) {
            errorMessage = err.error.message;
          } else if (typeof err?.error === 'string') {
            errorMessage = err.error;
          } else if (err?.message) {
            errorMessage = err.message;
          }

          this._notificationService.showNotification(errorMessage, NotificationType.ERROR);
        }
      });
  }



  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
